<template>
  <div class="banner">
        <div class="bannerCont">
          <img src="@/mobile/assets/banner/mobile-banner.png" alt="">
          <button @click="toDetail">了解更多</button>
        </div>
      </div>
</template>
<script>
export default {
  name: 'Banner',
  methods: {
    toDetail () {
      this.$router.push({ name: 'WifiNetwork' })
    }
  }
}
</script>

<style scoped lang="scss">
.banner {
   margin-top:0.98rem;
    width:100%;
    // background: -webkit-linear-gradient(left,#5749e6,#2fcfda); /* Safari 5.1-6.0 */
    // background: -o-linear-gradient(left,#5749e6,#2fcfda); /* Opera 11.1-12.0 */
    // background: -moz-linear-gradient(left,#5749e6,#2fcfda); /* Firefox 3.6-15 */
    // background: linear-gradient(left,#5749e6,#2fcfda); /* 标准语法 */
    .bannerCont{
      text-align:left;
      position: relative;
      img{
        width:100%;
      }
      button{
        position: absolute;
        bottom:2.1rem;
        left:0.3rem;
        width:1.3rem;
        height:0.4rem;
        background:transparent;
        border-radius:0.2rem;
        border:1px solid #fff;
        font-size:0.16rem;
        color:#fff;
        cursor: pointer;
      }
    }
  }
</style>
